import { render, staticRenderFns } from "./allocationStorehouseAuditOrdersList.vue?vue&type=template&id=2e0dcfb7&scoped=true"
import script from "./allocationStorehouseAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseAuditOrdersList.vue?vue&type=style&index=0&id=2e0dcfb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0dcfb7",
  null
  
)

export default component.exports